import React, { ReactElement, ReactNode } from 'react';
import { CompoundComponent } from 'ia-react-core/~/interfaces/CompoundComponent';
import { ResourceLoadRenderProps } from '../ResourceLoader';

/* istanbul ignore file */
export const Content = <Data, >({ children }: {
  children?: ReactNode | ((renderProps: ResourceLoadRenderProps<Data>) => ReactNode);
}) => <>{children}</>;
Content.type = Symbol('PaginationResourceLoader.Content');

export const FooterLeftContent = ({ children }: CompoundComponent) => children as ReactElement;
FooterLeftContent.type = Symbol('PaginationResourceLoader.FooterLeftContent');

export const FooterMiddleContent = ({ children }: CompoundComponent) => children as ReactElement;
FooterMiddleContent.type = Symbol('PaginationResourceLoader.FooterMiddleContent');
